import React, { useEffect, useState } from "react";
import AbhaCardUI from "../pages/Abha-card/abha-card-ui";
import { Modal, Input, message } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { setResentCount } from "../redux/slices/abhaSlice";
import VerifyNumberAbha from "../pages/abhanumber-details/verify-number-abha";
import { SendAadharOtp } from "../services";

import formBgImg from "../assets/image/Group 2147206200.png";
import about from "../assets/image/about_nha_pg_logo.png";

const ComparisonScreen = ({ downloadFlowToken, selectedAbhaCard }) => {
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [userData, setUserData] = useState(null);
  const [showCard, setShowCard] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [mobile, setMobile] = useState("");
  const [verifyNumberAbha, setVerifyNumberAbha] = useState(false);
  const [resMessage, setResMessage] = useState("");
  const resendCount = useSelector((state) => state.user.resentCount);
  const dispatch = useDispatch();

  useEffect(() => {
    const selected = localStorage.getItem("selectedIndex");
    const user = localStorage.getItem("userData");
    if (selected) setSelectedIndex(JSON.parse(selected));
    if (user) setUserData(JSON.parse(user));
  }, []);

  if (showCard) {
    return <AbhaCardUI downloadFlowToken={downloadFlowToken} />;
  }

  if (verifyNumberAbha) {
    return (
      <div className="col-12 col-md-6">
        <VerifyNumberAbha
          handleBack={() => setVerifyNumberAbha(false)}
          inputType="mobile"
          inputValue={mobile}
          otpType="abdm"
          autoComplete="off"
          initialResentCount={resendCount}
          setResMessage={setResMessage}
          resMessage={resMessage}
        />
      </div>
    );
  }

  const displayData =
    userData?.accounts?.find(
      (acc) =>
        acc.name === selectedAbhaCard?.name &&
        acc.ABHANumber?.split("-")[3] === selectedAbhaCard?.ABHANumber?.split("-")[3]
    ) || {};

  const account = displayData || userData || {};

  const normalizeData = (data = {}) => ({
    fullName: data?.fullname || data?.fullName || data?.name || "",
    dob: data?.dob || data?.abhaDob || "",
    gender: data?.gender || data?.abhaGender || "",
    abhaNumber: data?.healthIdNumber || data?.abhaNumber || data?.ABHANumber || "",
    abhaAddress: data?.abhaAddress || data?.preferredAbhaAddress || "",
    mobile: data?.mobileNo || data?.mobile || "",
  });

  const leftData = normalizeData(selectedIndex);
  const rightData = normalizeData(account);

  const comparisonFields = [
    { label: "Full Name",    left: leftData.fullName,    right: rightData.fullName },
    { label: "DOB",          left: leftData.dob,         right: rightData.dob },
    { label: "Gender",       left: leftData.gender,      right: rightData.gender === "M" ? "Male" : "Female" },
    { label: "ABHA Number",  left: leftData.abhaNumber,  right: rightData.abhaNumber },
    { label: "ABHA Address", left: leftData.abhaAddress, right: rightData.abhaAddress },
  ];

  const handleSendOtp = async () => {
    if (!mobile) { message.warning("Please enter a mobile number"); return; }
    try {
      const res = await SendAadharOtp({ headers: {}, data: { mobile } });
      if (res?.txnId) {
        message.success("OTP sent successfully");
        localStorage.setItem("txnId", res.txnId);
        localStorage.setItem("mobile", mobile);
        if (res?.resent_count !== undefined) dispatch(setResentCount(res.resent_count));
        setIsModalOpen(false);
        setVerifyNumberAbha(true);
        setResMessage(res.message);
      } else {
        message.error(res?.message || "Failed to send OTP");
      }
    } catch (err) {
      console.error(err);
      message.error("Something went wrong while sending OTP");
    }
  };

  return (
    <div className="col-12">
      <div
        className="lmop-card-wrap"
        style={{
          backgroundImage: `url(${formBgImg})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          maxWidth: "100%",
        }}
      >
        <div className="lmop-card-inner" style={{ padding: "28px 32px" }}>

          <h3 className="lmop-card-title" style={{ fontSize: "1.2rem" }}>
            Comparison Screen
          </h3>
          <p className="lmop-card-subtitle">
            Review your HIMS and ABDM data before linking
          </p>

          {/* ── DESKTOP: Table ── */}
          <div className="d-none d-md-block" style={{ marginBottom: "20px", maxHeight: "40vh", overflowY: "auto" }}>
            <table style={{ width: "100%", borderCollapse: "collapse", fontSize: "0.85rem" }}>
              <thead>
                <tr style={{ background: "#f0f4ff" }}>
                  {["Field", "HIMS Data", "ABDM Data", "Match"].map((h) => (
                    <th key={h} style={{
                      padding: "12px 16px",
                      textAlign: "left",
                      fontWeight: "700",
                      color: "#333",
                      borderBottom: "2px solid #e2e5ec",
                      whiteSpace: "nowrap",
                    }}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {comparisonFields.map((row, idx) => {
                  const isDifferent = row.left !== row.right;
                  return (
                    <tr key={idx} style={{
                      background: isDifferent ? "rgba(207,31,31,0.05)" : "transparent",
                      borderBottom: "1px solid #e2e5ec",
                    }}>
                      <td style={{ padding: "12px 16px", fontWeight: "700", color: "#333", whiteSpace: "nowrap" }}>
                        {row.label}
                      </td>
                      <td style={{ padding: "12px 16px", color: "#555" }}>
                        {row.left || "-"}
                      </td>
                      <td style={{ padding: "12px 16px", color: isDifferent ? "#cf1f1f" : "#00a870", fontWeight: "600" }}>
                        {row.right || "-"}
                      </td>
                      <td style={{ padding: "12px 16px", textAlign: "center" }}>
                        <span style={{
                          display: "inline-flex",
                          alignItems: "center",
                          justifyContent: "center",
                          width: "26px",
                          height: "26px",
                          borderRadius: "50%",
                          background: isDifferent ? "rgba(207,31,31,0.1)" : "rgba(0,168,112,0.1)",
                          color: isDifferent ? "#cf1f1f" : "#00a870",
                          fontSize: "0.75rem",
                          fontWeight: "800",
                        }}>
                          {isDifferent ? "✗" : "✓"}
                        </span>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>

          {/* ── MOBILE: Cards ── */}
          <div className="d-md-none" style={{ marginBottom: "20px", maxHeight: "40vh", overflowY: "auto" }}>
            {comparisonFields.map((row, idx) => {
              const isDifferent = row.left !== row.right;
              return (
                <div key={idx} style={{
                  background: isDifferent ? "rgba(207,31,31,0.04)" : "#f8faff",
                  border: `1px solid ${isDifferent ? "rgba(207,31,31,0.15)" : "#e8edf5"}`,
                  borderRadius: "10px",
                  padding: "10px 12px",
                  marginBottom: "8px",
                }}>
                  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "6px" }}>
                    <span style={{ fontSize: "0.7rem", fontWeight: "700", color: "#999", textTransform: "uppercase", letterSpacing: "0.5px" }}>
                      {row.label}
                    </span>
                    <span style={{
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "22px",
                      height: "22px",
                      borderRadius: "50%",
                      background: isDifferent ? "rgba(207,31,31,0.1)" : "rgba(0,168,112,0.1)",
                      color: isDifferent ? "#cf1f1f" : "#00a870",
                      fontSize: "0.7rem",
                      fontWeight: "800",
                    }}>
                      {isDifferent ? "✗" : "✓"}
                    </span>
                  </div>
                  <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "8px" }}>
                    <div>
                      <div style={{ fontSize: "0.65rem", color: "#aaa", fontWeight: "600", marginBottom: "2px" }}>HIMS</div>
                      <div style={{ fontSize: "0.8rem", color: "#333", fontWeight: "600", wordBreak: "break-all" }}>
                        {row.left || "-"}
                      </div>
                    </div>
                    <div>
                      <div style={{ fontSize: "0.65rem", color: "#aaa", fontWeight: "600", marginBottom: "2px" }}>ABDM</div>
                      <div style={{ fontSize: "0.8rem", color: isDifferent ? "#cf1f1f" : "#00a870", fontWeight: "600", wordBreak: "break-all" }}>
                        {row.right || "-"}
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>

          {/* Action buttons */}
          <div className="d-flex gap-3">
            <button
              type="button"
              onClick={() => window.location.reload()}
              style={{
                flex: 1,
                padding: "14px",
                borderRadius: "999px",
                border: "1.5px solid #d0d5e0",
                background: "transparent",
                color: "#555",
                fontFamily: "Manrope, sans-serif",
                fontWeight: "700",
                fontSize: "0.92rem",
                cursor: "pointer",
              }}
            >
              Cancel
            </button>
            <button
              type="button"
              onClick={() => setShowCard(true)}
              className="lmop-continue-btn"
              style={{ flex: 1, marginTop: 0 }}
            >
              Continue
            </button>
          </div>

          <div className="lmop-nha-row">
            <span className="lmop-nha-label">Approved by NHA</span>
            <img src={about} alt="NHA Logo" className="lmop-nha-logo" />
          </div>

        </div>
      </div>

      {/* Modal */}
      <Modal
        title="Enter Mobile Number"
        open={isModalOpen}
        onCancel={() => setIsModalOpen(false)}
        onOk={handleSendOtp}
        okText="Continue"
      >
        <Input
          value={mobile}
          onChange={(e) => setMobile(e.target.value)}
          placeholder="Enter mobile number"
          autoComplete="off"
          maxLength={10}
        />
      </Modal>
    </div>
  );
};

export default ComparisonScreen;